import React from "react";
import map from "lodash/map";
import round from "lodash/round";
import startsWith from "lodash/startsWith";

import { getDivisionDoc, getScore } from "util/lifterHelper";
import { Column } from "components/table/Table";
import { Meet } from "types";

import { scoreByMap } from "components/cells/scoreByMap";

const ScoreCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: Column;
  meet: Meet;
  style: React.CSSProperties & { fontSize: number };
}) => {
  const lifter = data;
  if (lifter.row === "header") {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else {
    return (
      <div style={style} className="table-cell-inner">
        {map(data.divisions, (lifterDivision, index) => {
          if (!lifterDivision.divisionId) {
            return null;
          }

          const division = getDivisionDoc(lifterDivision.divisionId, meet);
          if (!division) {
            return null;
          }

          if (division.hideOnBoard) {
            return null;
          }

          const scoreBy = scoreByMap[column.key];

          return (
            <div
              key={`${lifterDivision.divisionId}-${index}`}
              className="cell-row"
            >
              {round(
                getScore({
                  lifter,
                  division,
                  meet,
                  forecasted: startsWith(column.key, "forecasted"),
                  scoreByOverride: scoreBy,
                }),
                3
              )}
            </div>
          );
        })}
      </div>
    );
  }
};

export default ScoreCell;
